var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_form" },
    [
      _c(
        "b-row",
        { staticClass: "m-0" },
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex align-items-center px-2 mt-2",
              attrs: { lg: "12" }
            },
            [
              _c(
                "b-col",
                {
                  staticClass: "px-xl-2 mx-auto",
                  attrs: { sm: "12", md: "8", lg: "6" }
                },
                [
                  _c(
                    "b-card",
                    [
                      _c(
                        "b-card-title",
                        {
                          staticClass: "mb-1 font-weight-bold text-center",
                          attrs: { "title-tag": "h2" }
                        },
                        [_c("p", [_vm._v(_vm._s(_vm.formName))])]
                      ),
                      _c("b-card-text", { staticClass: "mb-2 text-center" }, [
                        _vm._v(
                          " Consulte aqui a situação e tratamento do formulário aberto, conforme o protocolo gerado."
                        ),
                        _c("br"),
                        _c("br")
                      ]),
                      _c(
                        "validation-observer",
                        { ref: "requestForm" },
                        [
                          _c(
                            "b-form",
                            {
                              staticClass: "mb-1 mt-2",
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.send($event)
                                }
                              }
                            },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "protocol_query.protocol_number"
                                    ),
                                    "label-for": "protocol_number"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      name: _vm.$t(
                                        "protocol_query.protocol_number"
                                      )
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "protocol_number",
                                                name: "protocol_number"
                                              },
                                              model: {
                                                value: _vm.protocolNumber,
                                                callback: function($$v) {
                                                  _vm.protocolNumber = $$v
                                                },
                                                expression: "protocolNumber"
                                              }
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "vx-row pt-2 print:hidden" },
                                [
                                  _c("div", { staticClass: "vx-col w-full" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex flex-row justify-end gap-4"
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass:
                                              "waves-effect float-right",
                                            attrs: {
                                              type: "submit",
                                              variant: "primary",
                                              disabled: !_vm.validateForm
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("action.consult")
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              variant: "outline-secondary"
                                            },
                                            on: { click: _vm.clearFields }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("action.clear"))
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("b-card-footer", [_c("form-footer")], 1)
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.list.length > 0
        ? _c(
            "b-row",
            { staticClass: "m-0" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center px-2 mx-auto",
                  attrs: { lg: "12", sm: "12", md: "12" }
                },
                [
                  _c(
                    "b-card",
                    [
                      _c(
                        "b-card-title",
                        {
                          staticClass: "mb-1 font-weight-bold text-center",
                          attrs: { "title-tag": "h2" }
                        },
                        [
                          _c("p", [
                            _vm._v(
                              "Histórico de Tratamento do " +
                                _vm._s(_vm.formName)
                            )
                          ])
                        ]
                      ),
                      _c("div", { staticClass: "vx-row mt-1 mb-10" }, [
                        _c(
                          "div",
                          { staticClass: "vx-col w-full" },
                          [
                            _c("b-table", {
                              attrs: {
                                items: _vm.list,
                                fields: _vm.fieldsDataTable,
                                "tbody-transition-props": _vm.transProps,
                                "sort-by": _vm.sortBy,
                                "primary-key": "created_at",
                                id: "table-handling",
                                striped: "",
                                hover: "",
                                "caption-top": "",
                                responsive: "sm"
                              },
                              on: {
                                "update:sortBy": function($event) {
                                  _vm.sortBy = $event
                                },
                                "update:sort-by": function($event) {
                                  _vm.sortBy = $event
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "cell(created_at)",
                                    fn: function(ref) {
                                      var created_at = ref.item.created_at
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.formatDate(created_at))
                                          )
                                        ])
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(description)",
                                    fn: function(ref) {
                                      var description = ref.item.description
                                      return [
                                        _c("span", {
                                          directives: [
                                            {
                                              name: "html-safe",
                                              rawName: "v-html-safe",
                                              value: description,
                                              expression: "description"
                                            }
                                          ],
                                          staticClass:
                                            "break-all whitespace-pre-wrap whitespace-pre-lin simple-editor simple-content"
                                        })
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(forwarding_description)",
                                    fn: function(ref) {
                                      var forwarding_description =
                                        ref.item.forwarding_description
                                      return [
                                        _c("span", {
                                          directives: [
                                            {
                                              name: "html-safe",
                                              rawName: "v-html-safe",
                                              value: forwarding_description,
                                              expression:
                                                "forwarding_description"
                                            }
                                          ],
                                          staticClass:
                                            "break-all whitespace-pre-wrap whitespace-pre-lin simple-editor simple-content"
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2924558067
                              )
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }